
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Communiquer efficacement avec Google Ads : guide pratique",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez comment utiliser Google Ads pour atteindre efficacement votre audience, améliorer votre visibilité et optimiser vos campagnes publicitaires en ligne.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Comment communiquer efficacement avec Google Ads ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Que ce soit pour enregistrer de meilleures ventes tout au long de l’année ou communiquer sur la disponibilité d’une nouvelle gamme de produits, une entreprise doit toujours s’assurer d’une excellente visibilité sur Internet.",
        },
      ],
    };
  },
};
